import { initializePaddle } from '@paddle/paddle-js'
import { isDevOrPreviewSite } from './general'
// import { handleCheckoutSuccess, handleCheckoutClose } from '../components/PaymentModal/components/PaddleBilling/PaddleBillingPay'

/**
 * Initialize Paddle Billing SDK using official @paddle/paddle-js package
 * Handles environment detection and client token configuration
 * @returns {Promise<Paddle|null>} Resolves with Paddle instance or null if initialization fails
 */
const PADDLE_DEV_TOKEN = 'test_51c5d36270ec6fac53d7bbd76fb'
const PADDLE_PROD_TOKEN = 'live_0c7bf7e43715faf3b26697822cb'

const PADDLE_CLIENT_TOKEN = isDevOrPreviewSite() ? PADDLE_DEV_TOKEN : PADDLE_PROD_TOKEN

export const PaddleInstance = async () => {
  try {
    const isDev = isDevOrPreviewSite()

    if (!PADDLE_CLIENT_TOKEN) {
      console.error('Paddle Billing client token not configured')
      return null
    }

    // Initialize Paddle with eventCallback for all checkout events
    const paddleInstance = await initializePaddle({
      token: PADDLE_CLIENT_TOKEN,
      environment: isDev ? 'sandbox' : 'production',
      eventCallback: async function (event) {
        // Route checkout events to attached handlers if they exist
        if (event.name === 'checkout.completed' && paddleInstance._checkoutSuccessHandler) {
          await paddleInstance._checkoutSuccessHandler(event.data)
        } else if (event.name === 'checkout.closed' && paddleInstance._checkoutCloseHandler) {
          paddleInstance._checkoutCloseHandler()
        }
      }
    })

    return paddleInstance
  } catch (error) {
    console.error('Failed to initialize Paddle Billing SDK:', error)
    return null
  }
}
